{
  "pt": {
    "inspiration": {
      "actions": {
        "delete": "Remover",
        "deleteMultipleInspirations": "Eliminar...",
        "delete_cancel": "Anular a eliminação",
        "goBackToInspirationLists": "Inspirações",
        "new": "Adicionar foto"
      },
      "labels": {
        "move_to_upload": "Coloque as fotografias na caixa abaixo ou clique para carregar.",
        "noInspirations": "Ainda não há inspirações",
        "upload_autoclose": "Esta janela fechar-se-á automaticamente se todas as imagens forem carregadas."
      },
      "toasts": {
        "upload_success": "{count} inspiração carregada com sucesso | {count} inspirações carregadas com sucesso"
      }
    }
  }
}
